import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IKnmIndexPage } from 'APIPackage/KnmModule/interfaces/IKnmIndexPage';
import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { apiGet, apiPost, apiPostZip } from 'APIPackage/MainModule/common/apiTools';
import { IErknmAnalyticsData } from 'APIPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsData';

import { IErknmAnalyticsProsecutorOrganizationFilterRaw } from '../interfaces/IErknmAnalyticsProsecutorOrganizationFilterRaw';

export async function fetchErknmAnalyticsProsecutorOrganization(
  page: number,
  filter?: IErknmAnalyticsProsecutorOrganizationFilterRaw,
  size = 100,
): Promise<IErknmAnalyticsData> {
  const params = new URLSearchParams();

  params.set('page', page.toString());
  params.set('size', size.toString());

  const response = await apiPostZip({
    url: `${getServiceBaseURL(APIServiceEnum.ANALYTIC_SERVICE)}/analytics/prosecutor-organizations/gzip?${params}`,
    body: filter ?? {},
  });

  const jsonData: IErknmAnalyticsData = await response.json();

  return jsonData;
}

export async function fetchErknmAnalyticsProsecutorOrganizationExport(
  format: ExportFormatsEnum,
  filter?: IErknmAnalyticsProsecutorOrganizationFilterRaw,
  columns?: string[],
): Promise<IExport> {
  const params = new URLSearchParams();

  params.append('format', format);

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.ANALYTIC_SERVICE)}/analytics/prosecutor-organizations/export?${params}`,
    body: !filter
      ? {}
      : {
          filter,
          view: {
            columnsCodes: columns,
          },
        },
  });
}

export async function fetchErknmAnalyticsProsecutorOrganizationFilter(): Promise<IErknmAnalyticsProsecutorOrganizationFilterRaw> {
  return apiGet<IErknmAnalyticsProsecutorOrganizationFilterRaw>(
    `${getServiceBaseURL(APIServiceEnum.ANALYTIC_SERVICE)}/analytics/prosecutor-organizations/filter`,
  );
}

export async function fetchErknmAnalyticsProsecutorOrganizationExportKnmList(
  r: string,
  c: string,
  f: string | null,
  format: ExportFormatsEnum,
  filter?: IErknmAnalyticsProsecutorOrganizationFilterRaw,
): Promise<IExport> {
  const params = new URLSearchParams();

  params.set('r', r);
  params.set('c', c);
  f && params.set('f', f);
  params.set('format', format);

  return apiPost<IExport>({
    url: `${getServiceBaseURL(
      APIServiceEnum.ANALYTIC_SERVICE,
    )}/analytics/prosecutor-organizations/export/knm?${params}`,
    body: filter ?? {},
  });
}

export async function fetchErknmAnalyticsProsecutorOrganizationKnm(
  f: string | null,
  page: number = 0,
  size: number = 50,
  filter?: IErknmAnalyticsProsecutorOrganizationFilterRaw,
  order?: string | null,
): Promise<IKnmIndexPage> {
  const params = new URLSearchParams();

  f && params.set('f', f);
  params.set('page', page.toString());
  params.set('size', size.toString());
  if (order) {
    params.append('order', order);
  }

  return apiPost<IKnmIndexPage>({
    url: `${getServiceBaseURL(APIServiceEnum.ANALYTIC_SERVICE)}/analytics/prosecutor-organizations/knm?${params}`,
    body: filter ?? {},
  });
}
